import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchInternalOrderAttachments } from '@/api/orders';
// IO shares the PO purchases endpoint — use a namespaced key to avoid cache collisions
export const internalOrderAttachmentKeys = {
  detail: (ioId: string) => ['internalOrderAttachments', ioId] as const,
};

export function useInternalOrderAttachments(ioId: string | null | undefined) {
  return useQuery({
    queryKey: internalOrderAttachmentKeys.detail(ioId ?? ''),
    queryFn: async () => {
      const res = await fetchInternalOrderAttachments(ioId!);
      return res.data;
    },
    enabled: !!ioId,
    staleTime: 30_000,
  });
}

export function useInternalOrderAttachmentsRefresh(ioId: string) {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: internalOrderAttachmentKeys.detail(ioId),
    });
}
